import { useCallback } from 'react';

type Ref<T> = React.RefCallback<T> | React.MutableRefObject<T> | null;

export function useComposedRefs<T>(...refs: Ref<T>[]) {
  return useCallback(
    (node: T) => {
      refs.forEach((ref) => {
        if (typeof ref === 'function') {
          ref(node);
        } else if (ref != null) {
          ref.current = node;
        }
      });
    },
    [refs],
  );
}
